import { render, staticRenderFns } from "./entryWithPage.vue?vue&type=template&id=9bebe51c"
import script from "./entryWithPage.vue?vue&type=script&lang=js"
export * from "./entryWithPage.vue?vue&type=script&lang=js"
import style0 from "./entryWithPage.vue?vue&type=style&index=0&id=9bebe51c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports